import { defineMessages } from '@jutro/locale';

export default defineMessages({
    editCoverages: {
        id: 'ml.endorsement.common.MLCECoveragePage.Edit coverages',
        defaultMessage: 'Edit coverages',
    },
    updatedCoverages: {
        id: 'ml.endorsement.common.MLCECoveragePage.Updated Coverages',
        defaultMessage: 'Updated Coverages'
    },
    estimatedReplacementCostMsg: {
        id: 'ml.endorsement.common.MLCECoveragePage.estimatedReplacementCostMsg',
        defaultMessage: 'Your estimated replacement cost for the contents is {replacementCost}.'
    },
    rentersEstimatedReplacementCostHelpText: {
        id: 'ml.endorsement.common.MLCECoveragePage.rentersEstimatedReplacementCostHelpText',
        defaultMessage: 'Estimated Replacement cost is the estimated amount of money it would take to repair or replace your personal property with items of like, kind and quality. This amount can be changed to reflect the amount of coverage that you need.'
    },
    homeEstimatedReplacementCostHelpText: {
        id: 'ml.endorsement.common.MLCECoveragePage.homeEstimatedReplacementCostHelpText',
        defaultMessage: 'Estimated Replacement cost is the estimated amount of money it would take to repair, replace or rebuild your home with materials of like, kind and quality. These estimates are based upon information given to us from a professional construction valuating service. This is our recommended amount necessary to rebuild your home, however, you can choose to change the amount of coverage for comparison. Your mortgage company may require you to maintain a specific level of replacement cost coverage on your policy.'
    },
    condoEstimatedReplacementCostHelpText: {
        id: 'ml.endorsement.common.MLCECoveragePage.condoEstimatedReplacementCostHelpText',
        defaultMessages: 'Estimated Replacement cost is the estimated amount of money it would take to repair, replace or rebuild your Condo unit with materials of like, kind and quality. These estimates are based upon information given to us from a professional construction valuating service. Many items attached as part of your condo unit may be your insurance responsibility as per the Condo Association By-Laws. Some Associations require unit owners to pay for interior construction materials such as drywall, paint, cabinetry, countertops and interior doors. It is important that you understand these requirements. If you are required to pay for such items, then you may need to increase your Replacement Cost coverage. This is the estimated amount needed to rebuild your unit if the association requires you to provide coverage.'
    },
    dwellingReplacementCostMsg: {
        id: 'ml.endorsement.common.MLCECoveragePage.dwellingReplacementCostMsg',
        defaultMessage: 'Your estimated replacement cost for the dwelling is {replacementCost}'
    },
    quotingPolicyChange: {
        id: 'ml.endorsement.common.MLCECoveragePage.Quoting policy change',
        defaultMessage: 'Quoting policy change'
    },
    currentPremium: {
        id: 'ml.endorsement.common.MLCECoveragePage.CURRENT PREMIUM',
        defaultMessage: 'CURRENT PREMIUM'
    },
    changesMadeToQuote: {
        id: 'ml.endorsement.common.MLCECoveragePage.Some changes were made to your quote',
        defaultMessage: 'Some changes were made to your quote'
    },
    premiumPerMonth: {
        id: 'ml.endorsement.common.MLCECoveragePage.premiumPerMonth',
        defaultMessage: '{premium}/month'
    },
    paNamedExcludeAllSelectedMessage: {
        id: 'ml.endorsement.common.MLCECoveragePage.paNamedExcludeAllSelectedMessage',
        defaultMessage: '{vehicleName} - All drivers have been checked for Named Driver Exclusion. Need to uncheck at least one driver or remove Named Driver Exclusion and comprehensive and collision coverages.'
    },
    paNamedExcludeNoneSelectedMessage: {
        id: 'ml.endorsement.common.MLCECoveragePage.paNamedExcludeNoneSelectedMessage',
        defaultMessage: '{vehicleName} - Must select a driver to exclude  or remove Named Driver Exclusion.'
    },
    suspendedLiability: {
        id: 'ml.endorsement.common.MLCECoveragePage.suspendedLiability',
        defaultMessage: '<p><strong>Warning:</strong>  If you suspend liability, the following coverages will also be suspended:  Bodily Injury, Property Damage, Combined Single Limit, Uninsured Motorist, Underinsured Motorist, Uninsured and Underinsured Bodily Injury, Uninsured Property Damage, Personal Injury Protection and Medical coverage.</p><br></br><p>In an accident, the vehicle owner and driver could be held personally liable for any damages.  The vehicle may be considered uninsured and may be subject to penalty under the state’s motor vehicle laws.</p>'
    },
    recalculateYourPremium: {
        id: 'ml.endorsement.common.MLCECoveragePage.RECALCULATE YOUR PREMIUM',
        defaultMessage: 'RECALCULATE YOUR PREMIUM'
    },
    functionalReplacementCostWarning: {
        id: 'ml.endorsement.common.MLCECoveragePage.Building Property Loss Settlement option...',
        defaultMessage: 'Building Property Loss Settlement option is not valid as both Guaranteed and Functional have been selected. Changes are required to either the Property Details or Coverages.'
    },
    savingPolicyChange: {
        id: 'ml.endorsement.common.savingPolicyChange.Saving policy change',
        defaultMessage: 'Saving policy change'
    },
    continue:{
        id: 'ml.endorsement.common.MLCECoveragePage.CONTINUE',
        defaultMessage: 'CONTINUE'
    },
    makeChangesHeader: {
        id: 'ml.endorsement.common.MLCECoveragePage.Make Changes',
        defaultMessage: 'Make Changes'
    },
    nextDesc: {
        id: "ml.endorsement.common.MLCECoveragePage.nextDesc",
        defaultMessage: "We'll check if {additionalChangesNeeded} next"
    },
    additionalChangesNeeded: {
        id: "ml.endorsement.common.MLCECoveragePage.additional changes are needed",
        defaultMessage: "additional changes are needed"
    },
    addressIssues: {
        id: "ml.endorsement.common.MLCECoveragePage.Please address the following issues:",
        defaultMessage: "Please address the following issues:"
    },
    navigateToDiffScreen: {
        id: 'ml.endorsement.common.MLCECoveragePage.navigateToDiffScreen',
        defaultMessage: 'To fix the error(s), you may need to navigate to a different screen from the <a>Make Changes</a> main screen.'
    }
});
